import { render, staticRenderFns } from "./ScrollCover.vue?vue&type=template&id=6946e4cf&scoped=true&"
import script from "./ScrollCover.vue?vue&type=script&lang=js&"
export * from "./ScrollCover.vue?vue&type=script&lang=js&"
import style0 from "./ScrollCover.vue?vue&type=style&index=0&id=6946e4cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../yeh/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946e4cf",
  null
  
)

export default component.exports